/**
 * WITS Data-Privacy helpers
 *
 * Accused names are masked based on the viewer's role:
 *
 *   guest / unauthenticated → "Anonymous"           (no identifying info)
 *   user (authenticated)    → first name only        (one name, as policy)
 *   admin / super-admin     → full name              (operational need)
 */

export type ViewerRole = 'guest' | 'user' | 'admin' | 'super-admin' | string;

export function maskName(
  name: string | null | undefined,
  role: ViewerRole,
): string {
  if (!name?.trim()) return '—';
  const r = (role ?? '').toLowerCase();

  // Admins see full names — they have operational need
  if (r === 'admin' || r === 'super-admin') return name.trim();

  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '—';

  // Authenticated regular users see first name only
  if (r === 'user') return parts[0];

  // Guests / public see no identifying information
  return 'Anonymous';
}

/** Returns true when the role warrants full PII access */
export function canViewFullNames(role: ViewerRole): boolean {
  const r = (role ?? '').toLowerCase();
  return r === 'admin' || r === 'super-admin';
}
